/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetVQResponsesErrorResponse, GetVQResponsesResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersResponses = (encounterId: number, signal?: AbortSignal) => {
  return api<GetVQResponsesResponse>({
    url: `/api/encounters/${encounterId}/responses`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersResponsesQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/responses`] as const;
};

export const getGetEncountersResponsesQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersResponses>>,
  TError = GetVQResponsesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersResponses>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEncountersResponsesQueryKey(encounterId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEncountersResponses>>> = ({ signal }) =>
    getEncountersResponses(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersResponses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersResponsesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersResponses>>
>;
export type GetEncountersResponsesQueryError = GetVQResponsesErrorResponse;

export function useGetEncountersResponses<
  TData = Awaited<ReturnType<typeof getEncountersResponses>>,
  TError = GetVQResponsesErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersResponses>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersResponses>>,
          TError,
          Awaited<ReturnType<typeof getEncountersResponses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersResponses<
  TData = Awaited<ReturnType<typeof getEncountersResponses>>,
  TError = GetVQResponsesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersResponses>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersResponses>>,
          TError,
          Awaited<ReturnType<typeof getEncountersResponses>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersResponses<
  TData = Awaited<ReturnType<typeof getEncountersResponses>>,
  TError = GetVQResponsesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersResponses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersResponses<
  TData = Awaited<ReturnType<typeof getEncountersResponses>>,
  TError = GetVQResponsesErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEncountersResponses>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersResponsesQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
